<div class="ml-round-bar">
  <div class="ml-round-scroll">
    @for (round of rounds; track round) {
      <button
        type="button"
        class="round-chip"
        [class.active]="round.name === roundSelected"
        (click)="selectRound(round)"
      >
        {{ round.title }}
      </button>
    }
  </div>
  @if (!isAdmin && isMe && mode !== "results") {
    <div class="joker-budget-strip">
      <div class="jb-coins">
        @for (n of [1, 2, 3, 4, 5]; track n) {
          <img
            src="/assets/imgs/joker-on.svg"
            class="jb-coin"
            [class.jb-spent]="n <= jokersUsed"
          />
        }
      </div>
      <span class="jb-label">
        @if (jokersUsed < MAX_JOKERS) {
          {{ MAX_JOKERS - jokersUsed }} de {{ MAX_JOKERS }} jokers disponibles
        } @else {
          Sin jokers disponibles
        }
      </span>
    </div>
  }
</div>

<div class="ml-content">
  @if (roundMatches && roundMatches.length > 0) {
    @for (match of roundMatches; track match; let i = $index) {
      <div
        class="match-card"
        [class.failed]="match.points === 0"
        [class.success]="match.points > 0"
        [class.joker]="match.useJoker"
      >
        <!-- Meta row: date + badges -->
        <div class="match-meta">
          <span class="match-date-lbl">{{
            match.date | date: "EEE d MMM · HH:mm"
          }}</span>
          <div class="match-badges">
            @if (match.useJoker) {
              <img src="/assets/imgs/joker-on.svg" class="joker-badge" />
            }
            @if (match.points !== null && match.points !== undefined) {
              <span
                class="pts-badge"
                [class.pts-success]="match.points > 0"
                [class.pts-fail]="match.points === 0"
              >
                @if (match.points > 0) {
                  +{{ match.points }} pts
                } @else {
                  0 pts
                }
              </span>
            }
          </div>
        </div>

        <!-- Scoreboard -->
        <div class="match-scoreboard">
          <div class="match-team">
            <img class="team-flag" src="{{ match.homeTeam.flag }}" />
            <span class="team-name">{{ match.homeTeam.name }}</span>
          </div>

          <div class="score-center">
            @if (
              isMe || (!isMe && match.roundIniTimestamp < currentTimestamp)
            ) {
              <input
                #input
                type="tel"
                maxlength="1"
                [(ngModel)]="match.homeGoals"
                [disabled]="
                  !isAdmin &&
                  mode !== 'results' &&
                  match.roundIniTimestamp < currentTimestamp
                "
                class="score-input"
                placeholder="–"
              />
              <span class="score-sep">:</span>
              <input
                #input
                type="tel"
                maxlength="1"
                [(ngModel)]="match.awayGoals"
                [disabled]="
                  !isAdmin &&
                  mode !== 'results' &&
                  match.roundIniTimestamp < currentTimestamp
                "
                class="score-input"
                placeholder="–"
              />
            } @else {
              <span class="score-locked">?</span>
              <span class="score-sep">:</span>
              <span class="score-locked">?</span>
            }
          </div>

          <div class="match-team match-team--away">
            <img class="team-flag" src="{{ match.awayTeam.flag }}" />
            <span class="team-name">{{ match.awayTeam.name }}</span>
          </div>
        </div>

        <!-- Penalties row (KO draw) -->
        @if (
          match.round !== "GROUP_STAGE" &&
          match.homeGoals !== null &&
          match.awayGoals !== null &&
          match.homeGoals === match.awayGoals
        ) {
          <div class="penalties-row">
            <span class="pen-label">Penaltis:</span>
            <mat-checkbox
              [(ngModel)]="match.homeTeam.checked"
              [checked]="match.homeTeam.checked"
              (change)="penaltiesChange(match, 1)"
              >{{ match.homeTeam.name }}</mat-checkbox
            >
            <mat-checkbox
              [(ngModel)]="match.awayTeam.checked"
              [checked]="match.awayTeam.checked"
              (change)="penaltiesChange(match, 2)"
              >{{ match.awayTeam.name }}</mat-checkbox
            >
          </div>
        }

        <!-- Real result (poll mode) -->
        @if (roundResults && mode === "poll" && roundResults[i]) {
          <div class="real-result-row">
            <span class="real-result-label">Resultado:</span>
            <span class="real-result-score"
              >{{ roundResults[i].homeGoals }} –
              {{ roundResults[i].awayGoals }}</span
            >
          </div>
        }

        <!-- Inline joker button -->
        @if (!isAdmin && isMe) {
          <div
            class="joker-bar"
            [class.joker-bar--active]="match.useJoker"
            [class.joker-bar--locked]="
              !isJokerEditable(match) && !match.useJoker
            "
          >
            <button
              type="button"
              class="joker-btn"
              [class.joker-btn--active]="match.useJoker"
              [class.joker-btn--disabled]="!isJokerEditable(match)"
              [class.joker-btn--maxed]="
                !match.useJoker &&
                !isJokerEditable(match) &&
                jokersUsed >= MAX_JOKERS
              "
              (click)="toggleJoker(match)"
            >
              <img
                src="/assets/imgs/joker-on.svg"
                class="joker-btn-icon"
                [class.joker-btn-icon--off]="!match.useJoker"
              />
              <span class="joker-btn-text">
                @if (match.useJoker) {
                  🃏 Joker activo — ×2 puntos
                } @else if (!isJokerEditable(match)) {
                  🃏 Joker bloqueado (ronda iniciada)
                } @else if (jokersUsed + jokerCost(match) > MAX_JOKERS) {
                  🃏 Sin jokers suficientes
                } @else {
                  🃏 Usar joker en este partido
                }
              </span>
              <span
                class="joker-cost-badge"
                [class.joker-cost-badge--active]="match.useJoker"
              >
                @for (c of [].constructor(jokerCost(match)); track c) {
                  🟣
                }
              </span>
            </button>
          </div>
        }

        <!-- Stats collapsible -->
        @if (match.roundIniTimestamp < currentTimestamp) {
          <div class="match-stats-section">
            <button
              type="button"
              class="stats-toggle"
              (click)="toggleMatchOptions(match)"
            >
              <mat-icon [class.rotated]="match.showOptions"
                >expand_more</mat-icon
              >
              <span>Estadísticas del partido</span>
            </button>
            @if (match.showOptions) {
              <div class="match-stats-row">
                <div class="stat-pill">
                  <span class="stat-val">{{ match.stats?.homeWin }}</span>
                  <span class="stat-lbl">1</span>
                </div>
                <div class="stat-pill">
                  <span class="stat-val">{{ match.stats?.draw }}</span>
                  <span class="stat-lbl">X</span>
                </div>
                <div class="stat-pill">
                  <span class="stat-val">{{ match.stats?.awayWin }}</span>
                  <span class="stat-lbl">2</span>
                </div>
                <div class="stat-pill stat-pill--joker">
                  <span class="stat-val">{{ match.stats?.jokers }}</span>
                  <img src="/assets/imgs/joker-on.svg" />
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  }
  @if (!roundMatches || roundMatches.length === 0) {
    <div class="empty-placeholder">
      <div class="empty-icon">⚽</div>
      <p class="empty-title">Sin partidos en esta fase</p>
      <p class="empty-sub">
        Selecciona otra ronda para ver los partidos disponibles.
      </p>
    </div>
  }
</div>
